export function hasExactlySixDigits (value = ''): boolean {
  return /\d{6}/.test(value)
}
